<template>
  <g fill-rule="evenodd">
    <path
      d="M10 13L5.24 8.38a.8.8 0 010-1.14.85.85 0 011.18 0L10 10.7l3.58-3.47a.85.85 0 011.18 0 .8.8 0 010 1.14L10 13z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DropdownIcon",
});
</script>
